import React from 'react';
import { Container, Box } from '@mui/material';
import ApplicationListTable from 'src/ui-component/ApplicationListTable/Index';
//import useLoginCheck from 'src/hooks/useLoginCheck';
import Breadcrumb from 'src/ui-component/Breadcrumb';
import { useLocation } from 'react-router-dom';

const ApplicationList: React.FC = () => {
  // Check if user logged in or not
  //useLoginCheck();
  const location = useLocation();
  const isDraft = location.pathname.split('/').pop() === 'draft-application';
  const columns = [
    'Application Number',
    // 'Application Type',
    'Application Title',
    'Applicant Name',
    'Last Activity Date',
    'Status',
    'Actions'
  ];
  return (
    <Container sx={{ mt: 2 }} className="main-table-container">
      <Breadcrumb
        PermitName={'Construction'}
        PageTitle={`${isDraft ? 'Draft' : 'All'} Applications`}
      />

      <Box mt={2}>
        <ApplicationListTable columns={columns} isDraft={isDraft} />
      </Box>
    </Container>
  );
};

export default ApplicationList;
